
const TextView = ({
  text = "",
  margin = "2",
  size = "md",
  color = "dark",
  bold = false,
  style = {},
  className,
  children,
}) => {
  const fontSizes = {
    sm: "fs-6",
    md: "fs-5",
    lg: "fs-4",
    xl: "fs-3",
  };
  return (
    <div className={`m-${margin}`}>
      <h5
        className={`${fontSizes[size]} placeholder-glow  m-${margin} text-${color} ${
          bold ? "fw-bold" : ""
        } ${className}`}
        style={style}
      >
        {text}
        {children}
      </h5>
    </div>
  );
};

export default TextView;
